import React, { useEffect, useRef, useState, useCallback } from 'react';
import { pageAtom, myNftBackAtom, metaMaskAtom, topMessageAtom } from '../../State';
import { useRecoilState } from 'recoil';

import './Header.css';

export default function ShowMessage() {
  const [topMessageState, setTopMessageState] = useRecoilState(topMessageAtom);

  //初期化
  useEffect(() => {
    if (topMessageState != null) {
      var duration = 3000;

      if (topMessageState?.type == 'joined') {
        duration = 5000;
      }

      setTimeout(() => {
        setTopMessageState(null);
      }, duration);
    }
  }, [topMessageState]);

  var type = 'topMessage';
  if (topMessageState?.type == 'copied') {
    type += ' copied';
  }
  if (topMessageState?.type == 'joined') {
    type += ' joined';
  }

  return (
    <>
      <div
        style={{
          opacity: topMessageState != null ? 1 : 0,
          top: topMessageState != null ? '40px' : '-20px',
        }}
        className={type}>
        {topMessageState?.message}
      </div>
    </>
  );
}
